export interface PermissionModel {
   roleId: string;
   permission: string;
}
